import { useSelector } from 'react-redux';
import { TStore } from '../basis/types/tstore';
import { useMeetingType } from './meeting-type';

// 会议类型
export const useMeetingBookingType = () => {
  const bookingMeetingType = useSelector((state: TStore.State) => state.booking.bookingMeetingType);
  const current = useMeetingType(bookingMeetingType);

  return { isBookingLive: current.isMeetingLive };
};
